import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CookieService from '../../services/cookie.service'
import './Login.css'
import './Slashcall.css'
import React, { useEffect, useState } from 'react';
import { authDashboard, handleAgentLogin, handleAgentLogout, initateSetup } from '../../services/authService';
import HttpService from '../../services/http.service';
import { ReactComponent as ShowPassword } from "./../../icons/showPassword.svg";
import { ReactComponent as HidePassword } from "./../../icons/hidePassword.svg";
import { ReactComponent as SipErrorIcon } from "./../../icons/sipLoginErrorIcon.svg";
import OtpVerification from './OtpVerification';
import { VerifyOTP, authUser, SendOTPtoAgent } from '../../services/agent.service';
import { getHeaderImages, getParam, getRoleStatus } from '../../services/util';
import { showErrorNotification } from '../common/NotiService';
import { useDispatch } from "react-redux"
import { setAleadyLoggedIn, setHomePageLogo, setActiveToggle, handleSipLoginFail, login, setMfaCheck, setLoginDetails, setmfaLoading } from '../../context/toolbarSlice';
import Logger from '../../services/logger.service';
import LocalStorageService from '../../services/localstorage.service';
import { aToolbar } from '../../toolbar';
import Dialog from '@mui/material/Dialog';
import RequestOTP from './RequestOTP';
import SimpleSwitch from '../Dispostion/SimpleSwitch';

function Login() {
    const formFields = [
        {
            label: 'Account ID',
            id: 'customer',
            type: 'string',
            helperText: 'Account ID is a required field, min 3 to max 50 characters allowed.',
            min: 3,
            max: 50
        },
        {
            label: 'Agent ID',
            id: 'agentid',
            type: 'string',
            helperText: 'Agent ID is a required field, min 2 to max 100 characters allowed.',
            min: 2,
            max: 100
        },
        {
            label: 'Phone Number',
            id: 'phoneNumber',
            type: 'tel',
            validations: {
                minLength: 10,
            },
            helperText: 'Phone Number is a required field, min 3 to max 17 characters allowed.',
            min: 3,
            max: 17
        },
        {
            label: 'Password',
            id: 'pin',
            type: 'password',
            validations: {
                autoComplete: 'change-pwd'
            },
            helperText: 'Password is a required field, min 3 to max 50 characters allowed.',
            min: 3,
            max: 50
        }
    ]
    const [value, setValue] = useState('1');
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    let location = useLocation();
    const isLoggedIn = useSelector((state) => state.toolbar.isLoggedIn);
    const isOTPVerified = useSelector((state) => state.toolbar.isOTPVerified)
    const [isPathnameOzonetel, setPathname] = useState(false);
    const isAlreadyLoggedIn = useSelector((state) => state.toolbar.alreadyLoggedIn);
    let rememberMe = CookieService.getCookie('rememberMe') === 'true';
    let loginDataViaApp = useSelector((state) => state.toolbar.loginViaAppData);
    let loginData = rememberMe ? CookieService.getCookieObj('dcRemeberMe') != null ? CookieService.getCookieObj('dcRemeberMe') : {} : {}
    const [formState, setFormState] = useState({ loginData, rememberMe })
    const [isLogInButtonClicked, setIsLogInButtonClicked] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [mfaRole, setMfaRole] = useState(false);
    const dispatch = useDispatch();
    const mode = useSelector((state) => state.toolbar.agent.mode);
    const headerLogo = useSelector((state) => state.toolbar.headerLogo);
    let showingToolbarInCrm = useSelector((state) => state.toolbar.showingToolbarInCrm);
    showingToolbarInCrm = Boolean(showingToolbarInCrm);
    const isSlashcall = window.location.href.includes('slashcall');
    const [isPageloading, setPageLoading] = useState(false);
    const fcmtoken = localStorage.getItem("fcmtoken") || null;
    const [verifyOtpDialog, setverfyOtpDialog] = useState(false);
    const [otpMethodTyp, setOtpMethodType] = useState('sms');
    const loginDetails = useSelector((state) => state.toolbar.loginDetails);
    const mfaCheck = useSelector((state) => state.toolbar.mfaCheck);
    const [ssoLogin, setSsoLogin] = useState(false);
    const [isAppInIframe, setIsAppInIframe] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const loginDataViaUrl = {
        customer: queryParams.get('customer'),
        agentid: queryParams.get('agentid'),
        phoneNumber: queryParams.get('phoneNumber'),
        pin: queryParams.get('pin'),
        action: queryParams.get('action'),
        sip: queryParams.get('sip'),
        apiKey: queryParams.get('apiKey'),
        UserAgentMapping: queryParams.get('UserAgentMapping')
    }
    //Logi n using query params
    useEffect(() => {
        if (!Boolean(authUser())) {
            if (loginDataViaUrl.customer !== null && (loginDataViaUrl.apiKey !== null || loginDataViaUrl.pin !== null) && loginDataViaUrl.agentId !== null) {
                if (loginDataViaUrl.sip && (loginDataViaUrl.sip === "true" || loginDataViaUrl.sip === true)) {
                    handleToggle("sip");
                }
                if (!loginDataViaUrl.UserAgentMapping || loginDataViaUrl.UserAgentMapping === "false") {
                    delete loginDataViaUrl[loginDataViaUrl.apiKey ? 'pin' : 'apiKey'];
                }
                setFormState(prevState => ({
                    ...prevState,
                    loginData: loginDataViaUrl
                }))
                if (loginDataViaUrl.action && loginDataViaUrl.action === "formLogin") {
                    handleLogin(loginDataViaUrl)
                }
            }
        }
    }, [])

    useEffect(() => {
        const url = new URL(window.location.href);
        // If opened as popup for SSO callback, post the data to opener and close
        try {
            if (window.opener && (url.searchParams.get("state") && (url.searchParams.get("code") || url.searchParams.get("error")))) {
                const state = url.searchParams.get("state");
                const code = url.searchParams.get("code");
                const error = url.searchParams.get("error");
                window.opener.postMessage({ cmd: "sso_oauth_callback", state, code, error }, "*");
                window.close();
                return;
            } else if (window.opener && url.searchParams.get("ssid")) {
                const ssid = url.searchParams.get("ssid");
                const error = url.searchParams.get("error");
                window.opener.postMessage({ cmd: "sso_token_callback", ssid, error }, "*");
                window.close();
                return;
            }
        } catch (e) {
            console.error(e)
        }
        if (url.searchParams.get('error') === "true" && url.searchParams.get('message')) {
            setPageLoading(false);
            let message = url.searchParams.get('message') || "";
            showErrorNotification(message);
        } else if (url.searchParams.get("state") && (url.searchParams.get("code") || url.searchParams.get("error"))) {
            let state = url.searchParams.get("state");
            let code = url.searchParams.get("code");
            let error = url.searchParams.get("error");
            if (error) {
                showErrorNotification(error);
                return;
            }
            try {
                state = JSON.parse(state);
                console.log("sso state: ", state, state.ssid, state.provider);
                let ssid = state.ssid;
                let provider = state.provider;
                handleAgentLogin({ action: "formLogin", ssid: ssid, code: code, provider: provider, sso: true }, setLoading);
            } catch (error) {
                showErrorNotification("Invalid Credentials");
                setSsoLogin(true);
            }
        } else if (url.searchParams.get("ssid")) {
            let ssid = url.searchParams.get("ssid");
            let error = url.searchParams.get("error");
            if (error) {
                showErrorNotification(error);
                return;
            }
            try {
                handleAgentLogin({ action: "formLogin", ssid: ssid, sso: true }, setLoading);
            } catch (error) {
                showErrorNotification("Invalid Credentials");
                setSsoLogin(true);
            }
        }
    }, []);

    const toggle = useSelector((state) => state.toolbar.activeToggle);
    let storedToggle = localStorage.getItem("activeToggle");
    if (storedToggle === null || storedToggle === undefined || storedToggle === "null" || storedToggle === "undefined") {
        storedToggle = "sip";
    }
    const activeToggle = toggle || storedToggle || "sip";
    if (storedToggle === "sip") {
        localStorage.setItem("activeToggle", "sip");
    }
    const sipLoginFaild = useSelector((state) => state.toolbar.sipLoginFaild)

    const crexdendoBackgroundStyle = {
        backgroundImage: `url(${process.env.PUBLIC_URL}/img/crexendo_bg.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '100vh'
    };

    const slashcallBackgroundStyle = {
        backgroundImage: `url(${process.env.PUBLIC_URL}/slashcall/slashcall-bg.png)`,
        backgroundColor: '#0b1b34',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    };

    useEffect(() => {
        if (loginDataViaApp && loginDataViaApp.customer !== null && loginDataViaApp.agentid !== null && loginDataViaApp.phoneNumber !== null && loginDataViaApp.pin !== null) {
            setFormState(prevState => ({
                ...prevState,
                loginData: loginDataViaApp
            }))
        }
    }, [loginDataViaApp])

    useEffect(() => {
        let closeT = localStorage.getItem('closeTab')
        let reconnect = localStorage.getItem('reconnect');
        if (isLoggedIn) {
            if (closeT === 'false' || closeT == null) {
                if (isOTPVerified) {
                    dispatch(setmfaLoading(false));
                    let currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.delete("ssid");
                    currentUrl.searchParams.delete("message");
                    currentUrl.searchParams.delete("code");
                    currentUrl.searchParams.delete("scope");
                    currentUrl.searchParams.delete("error");
                    currentUrl.searchParams.delete("session_state");
                    currentUrl.searchParams.delete("state");
                    currentUrl.searchParams.delete("action");
                    currentUrl.searchParams.delete("authuser");
                    currentUrl.searchParams.delete("prompt");
                    console.log("login->: navigating to home");
                    navigate({
                        pathname: "/home",
                        search: currentUrl.search,
                        hash: window.location.hash
                    })
                    AdminHeaderLogo();
                }
            }
            else {
                handleToggleOnLogout()
                console.log("login->mfa-false: navigating to login");
                navigate({
                    pathname: "/login",
                    search: window.location.search.replace(/[\\?|&]?(action=formLogin)/ig, ""),
                    hash: window.location.hash
                })
                if (isAlreadyLoggedIn && reconnect === 'true') {
                    dispatch(setAleadyLoggedIn(false))
                }
                checkPathnameOzonetel();
                AdminHeaderLogo()
            }
        }
        else {
            handleToggleOnLogout()
            AdminHeaderLogo()
            if (isAlreadyLoggedIn && reconnect === 'true') {
                dispatch(setAleadyLoggedIn(false))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, isOTPVerified]);

    useEffect(() => {
        console.log("Triggered! mfaCheck:", mfaCheck, "isOTPVerified:", isOTPVerified);
        if (mfaCheck && !isOTPVerified) {
            handleAdminLogin()
        }
        if (!mfaCheck && isOTPVerified) {
            console.log("login from mfacheck and isOtpverified");
            dispatch(setmfaLoading(false));
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete("ssid");
            currentUrl.searchParams.delete("message");
            currentUrl.searchParams.delete("code");
            currentUrl.searchParams.delete("scope");
            currentUrl.searchParams.delete("error");
            currentUrl.searchParams.delete("session_state");
            currentUrl.searchParams.delete("state");
            currentUrl.searchParams.delete("action");
            currentUrl.searchParams.delete("authuser");
            currentUrl.searchParams.delete("prompt");
            console.log("login->mfacheck: navigating to home");
            navigate({
                pathname: "/home",
                search: window.location.search,
                hash: window.location.hash
            });

        }
    }, [mfaCheck, isOTPVerified])

    const isAppLoadedInIframe = () => {
        try {
            return window.self !== window.top;
        } catch (error) {
            return true;
        }
    };

    useEffect(() => {
        setIsAppInIframe(isAppLoadedInIframe());
    }, []);

    const handleToggleOnLogout = () => {
        if (activeToggle === 'phone') {
            dispatch(setActiveToggle("sip"))
            LocalStorageService.setItem("activeToggle", 'sip')
        }
    }
    const handleSendOTP = async (type) => {
        try {
            setOtpMethodType(type)
            let sendOTPRequest = await SendOTPtoAgent(type)  // for sending OTP 
            if (sendOTPRequest.Status === "Success") {
                setMfaRole(false)
                setverfyOtpDialog(true)

            }
            else {
                showErrorNotification("Failed to send OTP")
            }
        }
        catch (e) {
            Logger.error("Error while sending OTP" + JSON.stringify(e))
        }
    }
    const handleAdminLogin = async () => {
        const role_mfa = getRoleStatus("ROLE_MFA")
        let resp = await authDashboard();  //  admin login start
        if (!resp) {
            console.log("Admin authentication failed");
        }
        if ((!loginDataViaUrl.UserAgentMapping || loginDataViaUrl.UserAgentMapping === "false") && role_mfa && (getParam("ENABLE_MFA_AGENT") === "true" || getParam("ENABLE_MFA_AGENT") === true)) {
            let isSip = loginDetails.isSip ? true : false;
            let email = loginDetails?.agentInfo?.email ?? '';
            if (isSip && email) {
                handleSendOTP('email');
            } else {
                setMfaRole(true);
            }
        } else {
            await initateSetup(loginDetails);
        }
    }
    const handlePasswordVisibility = (e) => {
        e.preventDefault()
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    function checkPathnameOzonetel() {
        let domain = window.location.href;
        // let domain = "https://cxhub.engage.personacloud.net"
        // let domain = "https://admin.engage.personacloud.net"
        // let domain = " https://cxagent.crexendocx.com/lo gin"
        // let domain = "https://cxagent.crexendovip.com/lo gin"
        if (domain.includes("engage") || domain.includes("crexendocx") || domain.includes("mavenir") || domain.includes('crexendovip') || domain.includes('slashcall')) {
            setPathname(true)
        }
        else {
            setPathname(false)
        }
    }


    const onClickRememberMe = (e) => {
        setFormState(prevState => ({
            ...prevState,
            rememberMe: e.target.checked
        }))
    }


    const handleUserChange = (event) => {
        setUser(event.target.value);
    };
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const onClickLogin = (event) => {
        setIsLogInButtonClicked(true);
        LocalStorageService.removeItem('maxPauseTime');
        LocalStorageService.removeItem('logoutStartTime');
        LocalStorageService.removeItem('pauseTimeCompleted');
        event.preventDefault();
        if (!isAlreadyLoggedIn) {
            handleLogin()  // trying to login
        } else {
            setIsLogInButtonClicked(false);
            let loginDataViaApp = JSON.parse(LocalStorageService.getItem('sameLoggedInAgentDetails'));
            let structuredloginDataViaApp = {
                customer: loginDataViaApp.user,
                agentid: loginDataViaApp.agentId,
                phoneNumber: loginDataViaApp.phoneNumber
            }
            handleAgentLogout(structuredloginDataViaApp || formState.loginData, false, false)
        }
    }

    const handleLogin = (loginDataViaParams = null) => {
        if (value === '1') {
            setLoading(true);
            // console.log(formState.loginData)
            let payload = structuredClone(formState.loginData);
            if (loginDataViaParams) {
                payload = loginDataViaParams;
                if (payload.sip && (payload.sip === "true" || payload.sip === true)) {
                    delete payload.phoneNumber;
                    payload.sip = true;
                } else {
                    payload.sip = false;
                }
            } else if (activeToggle === 'sip') {
                delete payload.phoneNumber
                payload.sip = true
            } else {
                payload.phoneNumber = formState.loginData.phoneNumber
                payload.sip = false
            }
            payload.sso = ssoLogin;
            // If SSO is enabled and app is inside an iframe, open a popup synchronously
            if (payload.sso && isAppInIframe) {
                try {
                    const features = "popup=yes,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=700";
                    const preOpened = window.open("about:blank", "sso_login", features);
                    if (preOpened) {
                        window.__ssoPopup = preOpened;
                    }
                } catch (e) { }
            }
            handleAgentLogin(payload, setLoading);    // onclicking agent login button constructing payload and trying to login 
            if (formState.rememberMe) {
                let remData = structuredClone(formState.loginData)
                remData.pin = null;
                CookieService.setCookie('dcRemeberMe', remData, 7);
            }
            else {
                CookieService.setCookie('dcRemeberMe', null, 7);
            }
            CookieService.setCookie('rememberMe', formState.rememberMe, 7);

        }
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === '2') {
            try {
                let currentURl = window.location.href;

                if (currentURl && !currentURl.includes('ozonetel')) {
                    let urlParts = currentURl.split('/')
                    if (currentURl.includes("crexendocx")) {
                        if (!currentURl.includes('cxadmin')) {
                            if (urlParts[2].includes('cxagent')) {
                                urlParts[2] = urlParts[2].replace("cxagent", 'cxadmin')
                            } else {
                                urlParts[2] = 'cxadmin.' + urlParts[2] + '/login';
                            }
                        }
                    } else if (urlParts[2].includes('slashcall')) {
                        urlParts[2] = urlParts[2].replace("agent", 'hub')
                    } else if (!currentURl.includes('cxhub')) {
                        if (urlParts[2].includes('cxagent')) {
                            urlParts[2] = urlParts[2].replace("cxagent", 'cxhub')
                        } else {
                            urlParts[2] = 'cxhub.' + urlParts[2] + '/login';
                        }

                    }
                    let cxHubURL = urlParts.join("/");
                    window.location.href = cxHubURL;
                } else {
                    window.location.href = HttpService.getURL('admin_login_url')
                }
            } catch (e) {
                console.error("error while switching tabs", e);
            }
        }
    }

    const onChangeInput = (e) => {
        let value = e.target.value;

        //for Mobile input issue
        if (navigator.userAgent.includes('Android') || navigator.userAgent.includes('iPhone')) {
            if (value[e.target.selectionStart - 1] === ' ') {
                e.target.setSelectionRange(e.target.selectionStart, e.target.selectionStart);
                return
            }
        }
        setFormState(prevState => ({
            ...prevState,
            loginData: { ...prevState.loginData, [e.target.id]: e.target.value }
        }))
    }

    async function AdminHeaderLogo() {
        let domainNew = window.location.href;
        checkPathnameOzonetel()
        if (!domainNew.includes("ozonetel") && !domainNew.includes("localhost")) {
            setPageLoading(true)
            let endpoint = getEndPoint(window.location.href)
            try {
                const urls = await getHeaderImages(endpoint);
                if (urls) {
                    urls.map((item) => {
                        if (item.includes('logo_')) {
                            setPathname(true);
                            dispatch(setHomePageLogo(item.slice(0, -1)))
                        }
                        if (item.includes('fav_')) {
                            const link = document.querySelector("link[rel='icon']");
                            if (link) {
                                link.href = item.slice(0, -1); // Replace 'new-favicon.ico' with the desired favicon image path
                            }
                        }
                    })
                }
                setPageLoading(false);

            } catch (e) {
                console.log("error while parsing header urls :", e);
                setPageLoading(false);
            }
        }
    }
    const getEndPoint = (url) => {
        const domain = new URL(url).hostname;
        const domainParts = domain.split(".");
        if (domainParts.length > 1) {
            return domainParts.slice(1).join(".")
        }
        else if (domainParts.length === 1) {
            return domainParts
        } else {
            return null; // or any default value you want to use for URLs with a single path
        }


    }
    const closeOtpDialog = async () => {
        setMfaRole(true);
        setverfyOtpDialog(false);
        dispatch(setmfaLoading(false));
    }
    const closeOTPrequestDia = async () => {
        setMfaRole(false);
        setLoading(false)
        setverfyOtpDialog(false)
        dispatch(login(false));
        dispatch(setMfaCheck(false));
        dispatch(setAleadyLoggedIn(false))
        dispatch(setLoginDetails({}));
    }
    const handleVerifyForOtp = async (otp, handleVerificationError) => {
        let api_key = loginDetails?.agentInfo?.user?.apiKey;
        let agentId = formState?.loginData?.agentid ?? loginDetails?.agentInfo?.agentId;
        let phone_no = formState.loginData.phoneNumber;
        let type = otpMethodTyp;
        let email = loginDetails?.agentInfo?.email ?? '';
        let verifyOTPData = await VerifyOTP({ otp, api_key, agentId, phone_no, type, email }) // for OTP verification
        console.log(verifyOTPData)
        if (verifyOTPData.data.status === "success") {
            console.log("after otp verify...")
            initateSetup(loginDetails);
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete("ssid");
            currentUrl.searchParams.delete("message");
            currentUrl.searchParams.delete("code");
            currentUrl.searchParams.delete("scope");
            currentUrl.searchParams.delete("error");
            currentUrl.searchParams.delete("session_state");
            currentUrl.searchParams.delete("state");
            currentUrl.searchParams.delete("action");
            currentUrl.searchParams.delete("authuser");
            currentUrl.searchParams.delete("prompt");
            console.log("login->otp verified: navigating to home");
            navigate({
                pathname: "/home",
                search: currentUrl.search,
                hash: window.location.hash
            })
        }
        else {
            handleVerificationError()
        }
    };
    const handleResendForOtp = async () => {
        handleSendOTP(otpMethodTyp)
    };


    const PageLoader = () => {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CircularProgress />
            </Box>
        )
    }

    const handleToggle = (toggle) => {
        dispatch(setActiveToggle(toggle))
        LocalStorageService.setItem("activeToggle", toggle)
        if (toggle === "phone" && sipLoginFaild) {
            dispatch(handleSipLoginFail(false));
        }
    }
    const handleSipError = () => {
        dispatch(handleSipLoginFail(false));

    }
    return (
        isPageloading ? <PageLoader /> :
            <div className='oz-login-container'>
                {(showingToolbarInCrm || isAppInIframe) ? <></> :
                    <>
                        {!isPathnameOzonetel && !isSlashcall && <img className='green-circle-top-left' src={`${process.env.PUBLIC_URL}/icons/greencircle.svg`} alt="Ozonetel" ></img >}
                        {isPathnameOzonetel && !isSlashcall && !window.location.href.includes("crexendovip") && <img className='vector-backgroung-img-left' src={`${process.env.PUBLIC_URL}/icons/loginpagevectorsLeft.svg`} alt="Ozonetel" ></img >}
                        {isPathnameOzonetel && !isSlashcall && !window.location.href.includes("crexendovip") && <img className='vector-backgroung-img-right' src={`${process.env.PUBLIC_URL}/icons/loginpagevectorRight.svg`} alt="Ozonetel" ></img >}
                    </>}
                <div className={isSlashcall ? "login_container slashcall-login" : !isPathnameOzonetel ? "login_container login-container-blue" : "login_container"} style={isSlashcall ? slashcallBackgroundStyle : window.location.href.includes("crexendovip") ? crexdendoBackgroundStyle : undefined}>
                    <div className={(showingToolbarInCrm || isAppInIframe) ? "login-left-inCrm" : "login-left"}>
                        {isSlashcall ?
                            <div className="slashcall-branding">
                                <img className="slashcall-logo" src={`${process.env.PUBLIC_URL}/slashcall/slashcall-logo-white.svg`} alt="Slashcall" />
                                <div className="slashcall-headline">
                                    <span className="slashcall-headline-1">Your Contact Center.</span>
                                    <span className="slashcall-headline-2">No Manager Required</span>
                                </div>
                                <div className="slashcall-subtitle">
                                    Set it up in minutes. Run it with confidence.<br />
                                    All you need to do is type.
                                </div>
                                <div className="slashcall-features">
                                    <div className="slashcall-feature-card">
                                        <img className="slashcall-feature-icon" src={`${process.env.PUBLIC_URL}/slashcall/icons/feature-type.svg`} alt="" />
                                        <span className="slashcall-feature-label">Just type what you need</span>
                                    </div>
                                    <div className="slashcall-feature-card">
                                        <img className="slashcall-feature-icon" src={`${process.env.PUBLIC_URL}/slashcall/icons/feature-route.svg`} alt="" />
                                        <span className="slashcall-feature-label">Route calls. Delight customers.</span>
                                    </div>
                                    <div className="slashcall-feature-card">
                                        <img className="slashcall-feature-icon" src={`${process.env.PUBLIC_URL}/slashcall/icons/feature-results.svg`} alt="" />
                                        <span className="slashcall-feature-label">Powerful results. Zero complexity.</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <>
                                {window.location.href.includes("crexendovip") ?
                                    <img className="admin-header-logo common-prop-header" src={`${process.env.PUBLIC_URL}/img/crexendo_logo.png`} alt="Crexendo" ></img >
                                    :
                                    <img className={window.location.href.includes("ccicx.ccicom") ? (showingToolbarInCrm || isAppInIframe) ? "admin-header-logo-inCrm cci-logo" : "admin-header-logo cci-logo" : (showingToolbarInCrm || isAppInIframe) ? "admin-header-logo-inCrm common-prop-header common-prop-header" : "admin-header-logo common-prop-header common-prop-header"} src={(headerLogo === null || headerLogo === "null") ? `${process.env.PUBLIC_URL}/icons/ozonetel-logo.svg` : headerLogo} alt="Ozonetel" ></img >
                                }
                                {!window.location.href.includes("crexendovip") && (
                                    <div className='oz-tb-login-page-text'>
                                        <div className={!isPathnameOzonetel ? "login-title login-title-white" : "login-title"}>Modernize your Contact Center Software today!</div>
                                        <div className={!isPathnameOzonetel ? "login-sub-title login-sub-title-white" : "login-sub-title"}>Enterprise-grade contact center suite built for fast-growing businesses</div>
                                    </div>
                                )}
                            </>
                        }
                    </div>
                    {sipLoginFaild ? <div className="login-right">
                        <div className="login-sip-errorpage-header">
                            <Button onClick={handleSipError} className="login-sip-errorpage-back-label"><lable>back</lable></Button>
                            <lable className="login-sip-errorpage-sip-label">SIP not assigned</lable>
                        </div>
                        <div className="login-sip-errorpage-icon"> <div className="login-sip-errorpage-outer-icon"><SipErrorIcon /></div></div>
                        <div className="login-sip-errorpage-sip-error">
                            <label> SIP number is not assigned. Please login </label>
                            <label>with phone number or contact administrator</label>
                        </div>
                        <div className="login-sip-errorpage-login-with-phone">
                            <Button onClick={() => { handleToggle("phone") }} className="login-sip-errorpage-login-with-phone-label">Login with Phone Number</Button>
                        </div>
                    </div> : <div className="login-right">
                        <div className="login-form-title"> Login </div>
                        <TabContext value={value}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example" className={(showingToolbarInCrm || isAppInIframe) ? "customLoginTabInCrm" : "customLoginTab"}>
                                <Tab label="Agent" value="1" />
                                {fcmtoken == null && <Tab label="Admin" value="2" />}
                            </TabList>
                            <TabPanel value="1" className="loginTabContainer">
                                <form onSubmit={onClickLogin}>
                                    <div className={'oz-tb-login-sub-header'}>
                                        <div className='oz-tb-login-toggles'>
                                            <Button className={(activeToggle === "sip" ? "oz-tb-login-active-toggle " : "") + "oz-tb-login-toggles-sip"} onClick={() => { handleToggle("sip") }}>SIP</Button>
                                            <Button className={(activeToggle === "phone" ? "oz-tb-login-active-toggle " : "") + "oz-tb-login-toggles-sip"} onClick={() => { handleToggle("phone") }}>Phone</Button>
                                        </div>
                                        <div className="oz-tb-sso-login-container">
                                            <Typography className="oz-tb-sso-login-container-label">SSO</Typography>
                                            <SimpleSwitch checked={ssoLogin} onChange={(e) => setSsoLogin(e.target.checked)} />
                                        </div>
                                    </div>
                                    {formFields.map((field, i) => (<React.Fragment key={field.id + i}> {activeToggle === "sip" && field.label === 'Phone Number' ? null : (
                                        (ssoLogin && field.id === "pin") ? null :
                                            (<div className={(i === 0) ? 'ozonetel-form-control ozonetel-form-control-spacing' : 'ozonetel-form-control'} key={field.id + i}>
                                                <label>{field.label}</label>
                                                <div className={field.type === 'password' ? "oz-tb-password-field-eye" : ''}>
                                                    <input
                                                        value={(formState.loginData[field.id] !== null && formState.loginData[field.id] !== undefined) ?
                                                            formState.loginData[field.id] :
                                                            field.label === "Account ID" ? (loginDataViaApp?.customer !== null ? loginDataViaApp?.customer : '') :
                                                                field.label === "Agent ID" ? (loginDataViaApp?.agentid !== null ? loginDataViaApp?.agentid : '') :
                                                                    field.label === "Phone Number" ? (loginDataViaApp?.phoneNumber !== null ? loginDataViaApp?.phoneNumber : '') :
                                                                        field.label === "Password" ? (loginDataViaApp?.pin !== null ? loginDataViaApp?.pin : '') : ''}
                                                        type={field.type === 'password' ? showPassword === true ? 'text' : 'password' : field.type || 'text'} id={field.id}
                                                        onChange={(e) => onChangeInput(e)}
                                                        onKeyDown={(e) => { if (e.code === 'Space' && field.type !== 'password') { e.preventDefault() } }}
                                                        placeholder={"Enter " + field.label}
                                                        className="oz-tb-login-text-field"
                                                        minLength={field.min}
                                                        maxLength={field.max}
                                                        autocomplete={field.type === 'password' ? 'new-password' : 'off'}
                                                    />
                                                    {field.type === 'password' &&
                                                        <div className='oz-tb-password-field-eye-icon' onClick={handlePasswordVisibility}>
                                                            {showPassword ? <HidePassword className='oz-tb-password-icon' /> : <ShowPassword className='oz-tb-password-icon' />}
                                                        </div>}
                                                </div>
                                                <div className='oz-tb-login-helperText'>
                                                    {(isLogInButtonClicked && (formState.loginData[field.id] === '' || formState.loginData[field.id] === null || formState.loginData[field.id] === undefined)) ?
                                                        ((formState.loginData[field.id] === 'pin' && ssoLogin) ? "" : field.helperText) : ''}
                                                </div>
                                            </div>))} </React.Fragment>
                                    ))}

                                    <div className='remember-me'>
                                        <FormControlLabel
                                            checked={formState.rememberMe}
                                            value={formState.rememberMe}
                                            control={<Checkbox id='rememberMe' size='small' />}
                                            label={<Typography variant='subtitle2' fontWeight={400} >Remember Me</Typography>}
                                            labelPlacement='end'
                                            onChange={(e) => onClickRememberMe(e)}

                                        />
                                    </div>
                                    <div className='ozonetel-form-control-inline'>
                                        <Box sx={{ position: 'relative', width: '100%' }}>
                                            <Button fullWidth type="submit" variant="contained" size="large" color={!isAlreadyLoggedIn ? 'primary' : 'error'} className="loginBtnLg" disabled={loading}>
                                                {!isAlreadyLoggedIn ? 'Login' : 'Logout'}
                                            </Button>
                                            {loading && (
                                                <CircularProgress
                                                    size={24}
                                                    sx={{
                                                        color: 'primary',
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        marginTop: '-12px',
                                                        marginLeft: '-12px',
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </div>
                                </form>
                            </TabPanel >
                            <TabPanel value="2" className="loginTabContainer">
                                <form onSubmit={handleLogin}>

                                    <div className="ozonetel-form-control ozonetel-form-control-spacing">
                                        <label className="form-label">User Name</label>
                                        <input required type="text" value={user} onChange={handleUserChange} placeholder="Enter User Name" autocomplete='off' />
                                    </div>
                                    <div className="ozonetel-form-control ozonetel-form-control-spacing">
                                        <label className="form-label">Password</label>
                                        <input required type="password" value={password} onChange={handlePasswordChange} placeholder="Enter Password" autocomplete='new-password' />
                                    </div>
                                    <div className="ozonetel-form-control-inline">
                                        <Button fullWidth type="submit" variant="contained" size="large" className="loginBtnLg" onClick={handleLogin}>
                                            Login
                                        </Button>
                                    </div>
                                </form>
                            </TabPanel>
                        </TabContext >
                    </div >
                    }
                    {mfaRole && (
                        <div className='admin-change-password-form'>
                            <Dialog open={mfaRole} >
                                <RequestOTP
                                    isSip={loginDetails?.isSip}
                                    email={loginDetails?.agentInfo?.email ?? ''}
                                    onClose={closeOTPrequestDia}
                                    onRequest={handleSendOTP}
                                />
                            </Dialog>
                        </div >
                    )}
                    {verifyOtpDialog && (
                        <Dialog open={verifyOtpDialog} >
                            <OtpVerification
                                open={verifyOtpDialog}
                                onClose={closeOtpDialog}
                                CloseAndLogout={closeOTPrequestDia}
                                isSip={loginDetails?.isSip}
                                phoneNumber={loginDetails.phoneNumber}
                                email={loginDetails?.agentInfo?.email ?? ''}
                                otpType={otpMethodTyp}
                                onClickVerify={handleVerifyForOtp}
                                onClickResend={handleResendForOtp}
                            />
                        </Dialog>
                    )}
                </div >
            </div>
    );
}

export default Login;